function customer_has_polytech_access(customer_id) {
  // Groups of the logged-in customer, resolved by the app proxy from the customer's metafield
  fetch("/a/api-request/aico/customer-groups", {
    headers: { Accept: "application/json" },
  })
    .then((response) => {
      if (!response.ok) {
        // Throw an error to catch it in the catch block
        throw new Error(response.status);
      }
      return response.json();
    })
    .then((response) => {
      let data = response.data;
      if (data) {
        let attributes = data.attributes;
        var nameExists = attributes.customerGroups.some(function (group) {
          return group.name === "Polytech Kunde";
        });

        if (!nameExists) {
          $(".product__qty_price_wrap").remove();
          $(".buy_button_form_wrapper").remove();
        }
      }
      $(".product__qty_price_wrap").removeClass("hidden");
      $(".buy_button_form_wrapper").removeClass("hidden");
    })
    .catch((error) => console.log(error));
}
function getParameterByName(name, url = window.location.href) {
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

$(document).ready(function () {
  // console.log("cartobject");
  let pricelist = aicoDiscountCheck();
  // console.log("pricelist", pricelist);

  var wishlistCount = $(".header__icons .uwl-count").text();
  if (wishlistCount == 0) {
    $(".header__icons .wishlist-link").removeClass("wishlist-has-val");
  } else {
    $(".header__icons .wishlist-link").addClass("wishlist-has-val");
  }

  $(document).on(
    "click",
    ".uwl-col-wishlist, .uwl-remove-wishlist",
    function () {
      var wishlistCount = $(".header__icons .uwl-count").text();
      if (wishlistCount == 0) {
        $(".header__icons .wishlist-link").removeClass("wishlist-has-val");
      } else {
        $(".header__icons .wishlist-link").addClass("wishlist-has-val");
      }
      if (wishlistCount == 1 && $(this).hasClass("uwl-remove-wishlist")) {
        setTimeout(function () {
          location.reload();
        }, 300);
      }
    }
  );

  // Set interval
  if ($(".uwl-wishlist-container").length > 0) {
    const load_wishlist_products = setInterval(function () {
      if (jQuery(".customer_logout .uwl-product-single-wrap").length > 0) {
        $(".customer_logout .uwl-product-single-wrap .wish-atc").remove();
        $(".customer_logout .uwl-product-single-wrap .product-price").remove();
        clearInterval(load_wishlist_products);
      }
    }, 1000);
  }
  $(".drawer-close-icon").on("click", function () {
    $("header-drawer .header__icon--menu").click();
  });
  // Function to equalize heights
  function equalizyHeights(section) {
    // Check window width
    if ($(window).width() > 990) {
      // Select and loop the container element of the elements you want to equalize
      $("" + section + " .product-grid").each(function () {
        // Reset heights to auto sbefore recalculating
        $(section + ".card__information", this).css("height", "auto");
        // Cache the highest
        var highestTexts = 0;
        // Select and loop the elements you want to equalize
        $("" + section + " .card__information").each(function () {
          // If this box is higher than the cached highest then store it
          if ($(this).height() > highestTexts) {
            highestTexts = $(this).height();
          }
        });

        // Set the height of all those children to whichever was highest
        $("" + section + " .card__information").height(highestTexts);
      });
    } else {
      // If window width is greater than or equal to 990, reset heights to auto
      $("" + section + " .card__information").css("height", "auto");
    }
  }

  // Call the function on document ready
  equalizyHeights(".bestseller-first-section");
  equalizyHeights(".aktionen-section");
  setTimeout(function () {
    equalizyHeights(".section-recently-viewed-products");
  }, 5000);

  // Bind the function to the window resize event
  $(window).resize(function () {
    // Call the function whenever the window is resized
    equalizyHeights(".bestseller-first-section");
    equalizyHeights(".aktionen-section");
    equalizyHeights(".section-recently-viewed-products");
  });

  // Wishlist code start
  /* for desktop */
  /*let wishlistCount = $(".wishlist-desktop .uwl-count").text();
  // console.log(wishlistCount);
  if (wishlistCount == 0) {
    $(".header__icon--wishlist").removeClass("wishlist-has-val");
  } else {
    $(".header__icon--wishlist").addClass("wishlist-has-val");
  }

  let wishlistCountmob = $(".header_wishlist .mobile-only .uwl-count").text();
  // console.log(wishlistCountmob);
  if (wishlistCountmob == 0) {
    $(".header_wishlist .mobile-only").removeClass("wishlist-has-val");
  } else {
    $(".header_wishlist .mobile-only").addClass("wishlist-has-val");
  }*/

  $(document).on(
    "click",
    ".uwl-col-wishlist, .uwl-remove-wishlist",
    function () {
      var $this = $(this);
      setTimeout(function () {
        let wishlistCountmob = $(
          ".header_wishlist .mobile-only .uwl-count"
        ).text();

        // console.log(wishlistCountmob);

        if (wishlistCountmob == 0) {
          $(".header_wishlist .mobile-only").removeClass("wishlist-has-val");
        } else {
          $(".header_wishlist .mobile-only").addClass("wishlist-has-val");
        }

        let wishlistCount = $(".wishlist-desktop .uwl-count").text();

        //console.log(wishlistCount);

        if (wishlistCount == 0) {
          $(".header__icon--wishlist").removeClass("wishlist-has-val");
        } else {
          $(".header__icon--wishlist").addClass("wishlist-has-val");
        }

        if (wishlistCount == 1 && $this.hasClass("uwl-remove-wishlist")) {
          location.reload();
        }
      }, 300);
    }
  );
  /* end desktop */
  // Wishlist code end

  if (
    typeof aico.login_customer_id != "undefined" &&
    aico.login_customer_id == ""
  ) {
    $(".card-information").find(".price").hide();
  }

  // Aico searchbar placeholder
  setTimeout(() => {
    $(".aico_custom_search").attr(
      "placeholder",
      $(".search .search__input").attr("placeholder")
    );
  }, 1500);

  // for the product page brands link
  $("a[data-brand]").each(function (e) {
    // e.preventDefault();
    let currentBrand = $(this).data("brand");
    let currentLang = document.documentElement.lang;
    if (currentLang == "de") {
      currentLang = "de_CH";
    }
    var query =
      "brands?filter[shouldExcludeProducts]=1&filter[isLightVersion]=1";
    let API_URL = aico_get_data("API_URL");
    fetch(API_URL + query)
      .then((res) => res.json())
      .then((data) => {
        let brands = data.data;
        let brand = brands.find((brand) => {
          let currentLangBrand = brand.attributes.translations.find(
            (translation) => translation.locale == currentLang
          );
          if (currentLangBrand.webName == currentBrand) {
            return brand;
          }
        });

        $(this).attr("href", $(this).attr("href") + "/" + brand.id);
      });
  });

  // Translate Wishlist page
  let has_wishlist = $(".uwl-wishlist-header-title").length;
  if (has_wishlist > 0) {
    $(".uwl-wishlist-header-title h2").text(window.wishlist.heading);
    setTimeout(() => {
      $(".uwl-product-single-wrap .btn.wish-atc").text(
        window.wishlist.addToCart
      );
      $(".uwl-wishlist-cart-added .uwl-wishlist-cart-title").text(
        window.wishlist.added
      );
      $(".uwl-wishlist-cart-added .uwl-wishlist-cart-btn").text(
        window.wishlist.view_cart
      );
      $(".uwl-wishlist-cart-added .uwl-wishlist-cart-btn").attr(
        "href",
        window.routes.cart_url
      );
    }, 2000);
  }

  // deselect the disabled option on product page
  const selectValues = {};
  const changeSelect = (select) => {
    if (select.selectedOptions[0].disabled) {
      select.value = selectValues[select.name];
    } else {
      selectValues[select.name] = select.value;
    }
  };
  let allSelect = document.querySelectorAll(
    ".product-form__input .select__select"
  );
  allSelect.forEach((select) => {
    selectValues[select.name] = select.value;
    select.addEventListener("change", () => changeSelect(select));
  });
});

$(document).ready(function () {
  // Get all the divs you want to track
  const divs = $(".collection .product-grid .grid__item .card-wrapper");

  // Set the initial CSS variables for each div
  divs.each(function (index) {
    const divHeight = $(this).outerHeight();
    $(this)
      .parent()
      .css("--div-height", divHeight + "px");
  });

  // Handle window resize
  window.onresize = function () {
    divs.each(function (index) {
      const divHeight = $(this).outerHeight();
      $(this)
        .parent()
        .css("--div-height", divHeight + "px");
    });
  };

  settings = {
    //Model Popup
    objModalPopupBtn: ".modalButton",
    objModalCloseBtn: ".overlay, .closeBtn",
    objModalDataAttr: "data-popup",
  };
  $(document).on("click", settings.objModalPopupBtn, function () {
    if ($(this).attr(settings.objModalDataAttr)) {
      var strDataPopupName = $(this).attr(settings.objModalDataAttr);

      //Fade In Modal Pop Up
      $(".overlay, #" + strDataPopupName).fadeIn();
    }
  });

  //On clicking the modal background
  $(settings.objModalCloseBtn).bind("click", function () {
    $(".modal").fadeOut();
  });

  jQuery.extend(jQuery.validator.messages, {
    required: "Dieses Feld ist erforderlich.",
    email: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
    accept: "Bitte fügen Sie einen gültigen Dateityp hinzu.",
    maxlength: "Diese Telefonnummer ist unvollständig.",
  });

  $(document).on("click", '.has_polytech_btn[type="button"]', function () {
    event.preventDefault();
    return false;
  });

  let OPDatum = $("#OPDatum_field").val();
  let PatientenID = $("#PatientenID_field").val();

  /*if((OPDatum != null && OPDatum != '') && (PatientenID != null && PatientenID != '')){
    $('button[data-popup="custom_attribute"]').addClass('cart__checkout-button');
    $('.cart__dynamic-checkout-buttons').removeClass('hidden');
    $('button.cart__checkout-button').attr('type','submit').attr('data-popup','').removeClass('modalButton');
  }*/

  $(document).on("click", ".save-attributes", function () {
    if (jQuery("form#cart-attribures").valid()) {
      let OPDatum = $("#OPDatum").val();
      let PatientenID = $("#PatientenID").val();
      $("#OPDatum_field").val(OPDatum);
      $("#PatientenID_field").val(PatientenID);
      localStorage.setItem("OPDatum", OPDatum);
      localStorage.setItem("PatientenID", PatientenID);
      $('button[data-popup="custom_attribute"]').addClass(
        "cart__checkout-button"
      );

      // $('.cart__dynamic-checkout-buttons').removeClass('hidden');
      // setTimeout(function () {
      //   // if (aico.login_customer_id == "7649959149872") {
      //   console.log("tetete");
      //   updateCartAttribute(OPDatum, PatientenID);
      //   // } else {
      //   $(".has_polytech_btn").attr("id", "checkout");
      //   $("button.cart__checkout-button")
      //     .attr("type", "submit")
      //     .trigger("click")
      //     .attr("data-popup", "")
      //     .removeClass("modalButton");
      //   $(".modal").fadeOut();
      //   // }
      // }, 2000);
      setTimeout(function () {
        console.log("Sending update to cart...");
        updateCartAttribute(OPDatum, PatientenID)
          .then((success) => {
            if (success) {
              // If the update is successful and `_price_item_discount` exists
              console.log(
                "Cart updated successfully, proceeding with checkout..."
              );
              $(".has_polytech_btn").attr("id", "checkout");
              $("button.cart__checkout-button")
                .attr("type", "submit")
                .trigger("click")
                .attr("data-popup", "")
                .removeClass("modalButton");
              $(".modal").fadeOut();
            } else {
              // If the cart is updated but `_price_item_discount` wasn't found
              console.log(
                "Cart updated, but no '_price_item_discount' property found."
              );
              // Handle the case when property is not present
            }
          })
          .catch((error) => {
            console.error("Failed to update cart:", error);
          });
      }, 1000); // Wait 1 seconds before updating
    }
  });

  $(document).on("click", ".continue-without-attributes", function () {
    $(".has_polytech_btn").attr("id", "checkout");
    $('button[data-popup="custom_attribute"]').addClass(
      "cart__checkout-button"
    );
    // $('.cart__dynamic-checkout-buttons').removeClass('hidden');
    $("button.cart__checkout-button")
      .attr("type", "submit")
      .trigger("click")
      .attr("data-popup", "")
      .removeClass("modalButton");
    $(".modal").fadeOut();
  });
});

function aicoDiscountCheck() {
  let has_polytech = $(".has_polytech_btn").length;
  let pricelist_condition = false;

  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      let cart_items = cart.items;
      if (cart_items.length > 0 && has_polytech > 0) {
        cart_items.forEach((item) => {
          if (
            item.properties &&
            item.properties.hasOwnProperty("_price_item_discount")
          ) {
            $(".has_polytech_btn").removeAttr("id");
          }
        });
      }
    });
}

// aico add
// aico.jq(document).find('.cart-item__old-price').hide();
$('input[aico_field="account_identity"]').change(function () {
  var selectedValue = $(this).val();
  var parentForm = $(this).closest("#aico_form");

  if (parentForm.length > 0) {
    if (selectedValue === "Privatkunde") {
      parentForm.find(".form-group").not(this.closest(".form-group")).hide();
      $("#control-9775537").hide();
    } else {
      parentForm.find(".form-group").show();
      $("#control-9775537").show();
    }
  }
});

// Function to update the cart-level attribute
function updateCartAttribute(OPDatum, PatientenID) {
  return new Promise((resolve, reject) => {
    // Return a promise
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        let has_polytech = $(".has_polytech_btn").length;
        let price_list = true;

        if (cart.items.length > 0 && has_polytech > 0 && price_list) {
          cart.items.forEach((item) => {
            if (
              item.properties &&
              item.properties.hasOwnProperty("_price_item_discount")
            ) {
              let cart_attributes = cart.attributes; // Get existing cart attributes
              console.log("Current cart attributes:", cart_attributes);

              // Prepare data for updating cart attributes
              const data = {
                attributes: { ...cart_attributes }, // Spread existing attributes to retain previous data
              };

              if (OPDatum) {
                data.attributes["OP Datum"] = OPDatum; // Update or add 'OP Datum'
              }

              if (PatientenID) {
                data.attributes["PatientenID"] = PatientenID; // Update or add 'PatientenID'
              }

              fetch("/cart/update.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
              })
                .then((response) => response.json())
                .then((updatedCart) => {
                  console.log("Cart updated with new attributes:", updatedCart);
                  aico.aico_shopify_cart = updatedCart;
                  resolve(true); // Resolve the promise on success
                })
                .catch((error) => {
                  console.error("Error updating cart:", error);
                  reject(false); // Reject on error
                });
            } else {
              // If the property _price_item_discount doesn't exist in the item properties
              console.log("Item does not have '_price_item_discount' property");
              // You can still resolve here, if you want to continue even when the condition is false
              resolve(true);
            }
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching cart:", error);
        reject(false);
      });
  });
}

var checkInterval = setInterval(function () {
  var $aicoTags = $(".aico-tags");

  if ($aicoTags.length > 0) {
    $aicoTags.each(function () {
      var $ul = $(this).find("ul.af-widgetCheck");
      if (
        $ul.children("li").length === 1 &&
        !$ul.find("li label .af-label").text().trim()
      ) {
        $(this).hide();
      }
    });

    // Clear the interval as the element is found and conditions checked
    clearInterval(checkInterval);
  }
}, 500); // Check every 0.5 second

// Stop checking after 1 minute if conditions aren't met
setTimeout(function () {
  clearInterval(checkInterval);
}, 40000); // 40 seconds

// AICO compare-at price on the product page. Resolves the AICO CHF price for
// the current variant's SKU and renders the crossed-out "list" price.
//   1) GET /products?filter[sku]={sku} -> AICO products for the sku
//   2) GET /products/{id}/all-prices   -> prices of each; the first product
//      with a CHF price for the sku wins
// Resolved per sku (and cached), so a variant switch looks up its own price.
// Requests send Accept: application/vnd.api+json (required by the V1 API).
var aico_pdp_price_cache = {}; // sku -> Promise<CHF value | null>
function aico_resolve_pdp_price(sku) {
  if (aico_pdp_price_cache[sku]) return aico_pdp_price_cache[sku];
  let API_URL = aico_get_data("API_URL");
  let headers = { Accept: "application/vnd.api+json" };
  aico_pdp_price_cache[sku] = fetch(
    API_URL + "products?filter[sku]=" + encodeURIComponent(sku),
    { headers }
  )
    .then(function (r) {
      return r.ok ? r.json() : null;
    })
    .then(function (j) {
      // filter[sku] returns the parent that has the sku as a variant and/or the
      // product whose own sku it is, but can also return an unrelated product
      // first (303428 -> 303427, CHF 95), so data[0] alone is not reliable.
      let products = j && Array.isArray(j.data) ? j.data : [];
      return Promise.all(
        products.map(function (p) {
          return fetch(API_URL + "products/" + p.id + "/all-prices", {
            headers: headers,
          })
            .then(function (r) {
              return r.ok ? r.json() : null;
            })
            .then(function (body) {
              let productSku = p.attributes ? p.attributes.sku : null;
              return body ? aico_find_chf_price(body, sku, productSku) : null;
            })
            .catch(function () {
              return null;
            });
        })
      );
    })
    .then(function (values) {
      let found = values.filter(function (v) {
        return v > 0;
      });
      return found.length ? found[0] : null;
    })
    .catch(function () {
      return null;
    });
  return aico_pdp_price_cache[sku];
}

function aico_apply_pdp_price(sku) {
  if (!sku) return;
  aico_setup_compare_price(sku);
}

// --- AICO compare-at price rendering -------------------------------------
// Rule (per Slack): ignore Shopify's compare-at entirely — always drive the
// crossed-out price from AICO. The AICO id is resolved via metafield/SKU, then
// /all-prices gives the price. If the AICO CHF price for the current variant is
// HIGHER than the Shopify selling price, show ~~AICO~~ selling, styled like the
// native sale — overriding any native Shopify compare-at if present.
// productSku is the AICO product's own sku: its productPrices only belong to
// that sku, never to a different one.
function aico_find_chf_price(pricesBody, sku, productSku) {
  try {
    let attr = pricesBody.data.attributes;
    if (Array.isArray(attr.variantPrices)) {
      let vp = attr.variantPrices.filter(function (p) {
        return (
          String(p.variantSku) === String(sku) &&
          p.currency &&
          p.currency.name === "CHF"
        );
      });
      if (vp.length) return vp[0].value;
    }
    if (
      Array.isArray(attr.productPrices) &&
      String(productSku) === String(sku)
    ) {
      let pp = attr.productPrices.filter(function (p) {
        return p.currency && p.currency.name === "CHF";
      });
      if (pp.length) return pp[0].value;
    }
  } catch (e) {}
  return null;
}

// Apply the AICO crossed-out price to a single Dawn .price element.
// Shared by the PDP and by product cards. Shows ~~AICO~~ selling only when the
// AICO value is higher than the actual selling price; overrides native sales.
function aico_apply_to_price_el(priceEl, aicoVal) {
  if (!priceEl || aicoVal == null) return;

  // Actual selling price: the sale price when on sale, otherwise the regular.
  let onSale = priceEl.classList.contains("price--on-sale");
  let sellEl =
    (onSale && priceEl.querySelector(".price__sale .price-item--sale")) ||
    priceEl.querySelector(".price__regular .price-item--regular");
  if (!sellEl) return;
  let shopText = sellEl.textContent.trim();
  let shopVal = parseFloat(shopText.replace(/[^\d.]/g, ""));
  if (isNaN(shopVal)) return;

  // Only cross out when the AICO price is actually higher than what we sell at.
  if (!(aicoVal > shopVal)) return;

  // Reuse the displayed currency prefix (e.g. "CHF ") so the format matches.
  let prefix = (shopText.match(/^[^\d]*/) || ["CHF "])[0] || "CHF ";
  let compareStr = prefix + Number(aicoVal).toFixed(2);

  let compareEl = priceEl.querySelector(".price__sale s.price-item--regular");
  // Idempotent: if we've already set this exact AICO value, only make sure the
  // labels are there (prevents the MutationObserver from looping on our own change).
  if (!(compareEl && compareEl.textContent.trim() === compareStr && onSale)) {
    if (compareEl) compareEl.textContent = compareStr;
    priceEl.classList.add("price--on-sale");

    // We're showing the AICO price (crossed-out compare). Per spec the "Sale"
    // badge must NOT appear for AICO-driven prices — only genuine Shopify
    // compare-at prices keep their badge. Hide the native sale badge here.
    let saleBadge = priceEl.querySelector(".price__badge-sale");
    if (saleBadge) saleBadge.style.display = "none";
  }

  aico_add_price_labels(priceEl, compareEl);
}

// Bracket labels for pricelist products (T139155): "(UVP, exkl. MwSt.)" after the
// crossed-out AICO price and "(B2B-Preis, exkl. MwSt.)" after the selling price,
// one pair per line. Texts come from the locales (window.aicoPriceLabels, set in
// theme.liquid). Only called while the AICO price is crossed out; wraps only what
// is not wrapped yet, so re-applies from the MutationObservers don't loop.
function aico_add_price_labels(priceEl, compareEl) {
  let labels = window.aicoPriceLabels;
  let saleEl = priceEl.querySelector(".price__sale .price-item--sale");
  if (!labels || !compareEl || !saleEl) return;
  // A product with a real Shopify compare-at price is a SALE product, not a
  // pricelist product, so it keeps the plain crossed-out sale look and gets no
  // UVP/B2B labels (T139155 follow-up, Nina 23.09). Without price--aico the
  // strike-through in custome.css does not apply either, so the sale renders
  // exactly as it did before. The Meilisearch grid already skips AICO on
  // data-native-sale cards (meilisearch-product-grid.js).
  if (priceEl.dataset && priceEl.dataset.nativeSale === "true") return;
  priceEl.classList.add("price--aico");
  // compareEl sits in a <span data-nosnippet> wrapper (snippets/price.liquid).
  aico_price_line(compareEl.parentNode, "uvp", labels.uvp);
  aico_price_line(saleEl, "b2b", labels.b2b);
}

// Moves a price into <span class="aico-price-line">price (label)</span>. One line
// per price keeps the block as narrow as its longest line, so on the PDP it stays
// next to the quantity field in every language.
function aico_price_line(priceNode, type, text) {
  if (priceNode.parentNode.classList.contains("aico-price-line")) return;
  let line = document.createElement("span");
  line.className = "aico-price-line";
  priceNode.parentNode.insertBefore(line, priceNode);
  line.appendChild(priceNode);
  line.appendChild(aico_price_label(type, text));
}

function aico_price_label(type, text) {
  let el = document.createElement("span");
  el.className = "aico-price-label aico-price-label--" + type;
  el.textContent = "(" + text + ")";
  return el;
}

function aico_apply_compare_price(aicoVal) {
  let priceEl =
    document.querySelector(".product__price_wrap .price") ||
    document.querySelector(".price--large");
  aico_apply_to_price_el(priceEl, aicoVal);

  // The labels already say "exkl. MwSt.", so hide the separate "(exkl. MwSt.)"
  // note next to the price while they are shown.
  let wrap = priceEl && priceEl.closest(".product__price_wrap");
  let taxNote = wrap && wrap.querySelector(".product__tax");
  if (taxNote) {
    taxNote.classList.toggle(
      "aico-price-labels-tax",
      priceEl.classList.contains("price--aico")
    );
  }
}

function aico_setup_compare_price(initialSku) {
  let currentSku = initialSku;
  function apply() {
    let sku = currentSku;
    aico_resolve_pdp_price(sku).then(function (val) {
      // Skip if the variant changed while this sku's price was loading.
      if (sku === currentSku) aico_apply_compare_price(val);
    });
  }
  apply();

  // Re-apply whenever the price block is re-rendered by another script
  // (Dawn variant swap, aico-price-list.js, etc.) so the crossed-out price is
  // not wiped. apply() is idempotent — it early-returns once the crossed-out
  // <s> already shows the AICO value, so this never loops.
  let observed =
    document.querySelector(".product__qty_price_wrap") ||
    document.querySelector(".product__price_wrap") ||
    document.querySelector("product-info");
  if (observed && typeof MutationObserver !== "undefined") {
    let pending = false;
    let obs = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () {
        pending = false;
        apply();
      }, 60);
    });
    obs.observe(observed, { childList: true, subtree: true });
  }

  // Track the selected variant's SKU so re-applies use the right AICO price.
  if (
    typeof subscribe === "function" &&
    typeof PUB_SUB_EVENTS !== "undefined" &&
    PUB_SUB_EVENTS.variantChange
  ) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      let v = event && event.data && event.data.variant;
      if (v && v.sku) currentSku = v.sku;
      setTimeout(apply, 350);
    });
  }
}

// --- AICO crossed-out price on standard product cards (homepage featured,
// related products, search, collage, etc.). Resolves each card's AICO price by
// SKU (batched) and applies the same rule as the PDP. EXCLUDES collection pages
// (handled separately by the external AICO filter app) and any .aico-filter-app
// grid. Acts only when a card's price is rendered (Dawn gates it to customers).
function aico_cards_setup() {
  let path = (window.location && window.location.pathname) || "";
  if (
    path.indexOf("/collections/") === 0 ||
    (document.body && document.body.classList.contains("template-collection"))
  ) {
    return;
  }

  let API_URL = aico_get_data("API_URL");
  let skuVal = {}; // sku -> AICO CHF value (null once looked up with no match)

  function fetchPrices(skus) {
    let need = skus.filter(function (s) {
      return s && skuVal[s] === undefined;
    });
    if (!need.length) return Promise.resolve();
    let chunks = [];
    for (let i = 0; i < need.length; i += 25) chunks.push(need.slice(i, i + 25));
    return Promise.all(
      chunks.map(function (chunk) {
        let url =
          API_URL +
          "products?filter[sku]=" +
          chunk.map(encodeURIComponent).join(",") +
          "&page[size]=100";
        return fetch(url, {
          headers: { Accept: "application/vnd.api+json" },
        })
          .then(function (r) {
            return r.ok ? r.json() : null;
          })
          .then(function (j) {
            if (j && Array.isArray(j.data)) {
              j.data.forEach(function (p) {
                let a = p.attributes || {};
                let pp = a.productPrices || [];
                // The batched list response strips currency, but productPrices[0]
                // is reliably the CHF price (verified across the catalogue). The
                // exact product-sku match carries the per-variant price.
                if (a.sku != null && pp.length) skuVal[String(a.sku)] = pp[0].value;
              });
            }
          })
          .catch(function () {});
      })
    ).then(function () {
      need.forEach(function (s) {
        if (skuVal[s] === undefined) skuVal[s] = null;
      });
    });
  }

  function process() {
    let cards = Array.prototype.slice
      .call(document.querySelectorAll(".card-wrapper[data-aico-sku]"))
      .filter(function (c) {
        return (
          !c.hasAttribute("data-aico-done") &&
          !c.closest(".aico-filter-app") &&
          c.querySelector(".price")
        );
      });
    if (!cards.length) return;
    let skus = [];
    cards.forEach(function (c) {
      c.setAttribute("data-aico-done", "1");
      let s = c.getAttribute("data-aico-sku");
      if (s && skus.indexOf(s) === -1) skus.push(s);
    });
    fetchPrices(skus).then(function () {
      cards.forEach(function (c) {
        let s = c.getAttribute("data-aico-sku");
        aico_apply_to_price_el(c.querySelector(".price"), skuVal[String(s)]);
      });
    });
  }

  process();
  // Sections render/re-render cards async (recently viewed, sliders, etc.).
  if (typeof MutationObserver !== "undefined") {
    let pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () {
        pending = false;
        process();
      }, 250);
    }).observe(document.body, { childList: true, subtree: true });
  }
}

if (document.readyState !== "loading") {
  aico_cards_setup();
} else {
  document.addEventListener("DOMContentLoaded", aico_cards_setup);
}

// --- AICO crossed-out price on the COLLECTION grid -----------------------
// The collection grid is rendered by the external "aico-cloud-erp-connector"
// app (aico-filter.js), NOT the theme — so its cards (.af-productCard) use
// different markup from Dawn cards and we post-process them client-side.
//
// Per card we have: the /products/{handle} link, .uwl-col-wishlist with
// data-variant (Shopify variant id) and data-price (selling price in cents).
// There is NO sku on the card, so we resolve it via /products/{handle}.js.
//
// CHF value source: the batched /products?filter[sku]= list response. Its
// productPrices entries are stripped of currency, but productPrices[0] is
// reliably the CHF price (verified across the catalogue: index 0 is always CHF,
// order matches /all-prices, and no product uses per-variant variantPrices) — so
// we read the value straight from the batch, with no extra /all-prices call. A
// sku can match a parent AND a variant-as-product, so we key by exact
// attributes.sku. Display rule is the shared one: cross out only when the AICO
// CHF value > the card's selling price.
//
// Performance: collections can have 200+ products, so cards are processed
// LAZILY via an IntersectionObserver (only when scrolled near the viewport),
// the sku lookups are BATCHED via filter[sku], and every result is promise-
// cached. Gated to logged-in customers (aico.login_customer_id).
function aico_filter_cards_setup() {
  if (window.__aicoFilterCardsInit) return;
  let body = document.body;
  let isCollection =
    body &&
    (body.classList.contains("template-collection") ||
      body.classList.contains("template-search"));
  if (!isCollection && !document.querySelector(".aico-filter-app")) return;
  window.__aicoFilterCardsInit = true;

  // The filter app + the aico global are injected async; wait for both.
  let tries = 0;
  let waiter = setInterval(function () {
    tries++;
    let container =
      document.querySelector(".aico-filter-app") ||
      document.getElementById("ProductGridContainer");
    let aicoReady = typeof aico !== "undefined" && aico !== null;
    if (container && aicoReady) {
      clearInterval(waiter);
      aico_filter_cards_start(container);
    } else if (tries > 40) {
      clearInterval(waiter); // ~20s — give up quietly
    }
  }, 500);
}

// One-time stylesheet for the collection af-cards, matching the PDP sale colors
// (assets/custome.css: active price #f05138; list price #666, not crossed out
// since T139155). Scoped to .af-productCard so it never leaks into Dawn
// surfaces.
function aico_filter_ensure_style() {
  if (document.getElementById("aico-collection-price-style")) return;
  let st = document.createElement("style");
  st.id = "aico-collection-price-style";
  st.textContent =
    // T139155 (22.09): the UVP price is no longer struck through. "none" also
    // overrides the <s> browser default; the red B2B price is unchanged.
    ".af-productCard .aico-list-price{text-decoration:none;color:#666;font-weight:400;margin-right:6px;}" +
    ".af-productCard.aico-on-sale .af-productCard-price{color:#f05138;}";
  (document.head || document.documentElement).appendChild(st);
}

function aico_filter_cards_start(container) {
  // Only logged-in customers see the AICO crossed-out "list" price. The af
  // cards render their selling price even for anonymous visitors, but we add
  // nothing (and fire no API calls) when logged out.
  if (!(typeof aico !== "undefined" && aico && aico.login_customer_id)) return;

  // Match the PDP sale styling (assets/custome.css + section-main-product.css):
  // list price #666 (not crossed out, T139155), active selling price #f05138
  // (red). No "Sale" badge — only genuine Shopify compare-at prices show one.
  aico_filter_ensure_style();

  let API_URL = aico_get_data("API_URL");
  let headers = {
    Accept: "application/vnd.api+json",
  };

  let skuPromise = {}; // "handle|variantId" -> Promise<sku|null>
  let valPromise = {}; // sku -> Promise<chfValue|null>

  // handle + Shopify variant id -> sku (via the storefront product JSON).
  function resolveSku(handle, variantId) {
    let key = handle + "|" + variantId;
    if (skuPromise[key]) return skuPromise[key];
    skuPromise[key] = fetch("/products/" + handle + ".js")
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (pj) {
        if (pj && Array.isArray(pj.variants)) {
          let v =
            pj.variants.filter(function (x) {
              return String(x.id) === String(variantId);
            })[0] || pj.variants[0];
          return v && v.sku ? String(v.sku) : null;
        }
        return null;
      })
      .catch(function () {
        return null;
      });
    return skuPromise[key];
  }

  // Batch-resolve skus -> CHF value, read straight from the filter[sku] list
  // response (chunks of 25). That response strips currency, but productPrices[0]
  // is reliably the CHF price — verified across the catalogue: index 0 is always
  // CHF, its order matches /all-prices, and no product uses per-variant
  // variantPrices — so we skip a second /all-prices round-trip per card. A sku
  // can match a parent AND a variant-as-product; we key by exact attributes.sku
  // to pick our variant's own price.
  function resolveVals(skus) {
    let need = skus.filter(function (s) {
      return s && !valPromise[s];
    });
    for (let i = 0; i < need.length; i += 25) {
      let chunk = need.slice(i, i + 25);
      let p = fetch(
        API_URL +
          "products?filter[sku]=" +
          chunk.map(encodeURIComponent).join(",") +
          "&page[size]=100",
        { headers: headers }
      )
        .then(function (r) {
          return r.ok ? r.json() : null;
        })
        .then(function (j) {
          let map = {};
          if (j && Array.isArray(j.data)) {
            j.data.forEach(function (pp) {
              let a = pp.attributes || {};
              let prices = a.productPrices || [];
              if (a.sku != null && prices.length) {
                map[String(a.sku)] = prices[0].value;
              }
            });
          }
          return map;
        })
        .catch(function () {
          return {};
        });
      chunk.forEach(function (s) {
        valPromise[s] = p.then(function (map) {
          return s in map ? map[s] : null;
        });
      });
    }
    return Promise.all(
      skus.map(function (s) {
        return s ? valPromise[s] : Promise.resolve(null);
      })
    );
  }

  // Inject (or re-inject) the crossed-out AICO list price into a card, mirroring
  // the PDP sale look: ~~list~~ before the selling price and the selling price
  // turned red via the .aico-on-sale class (no "Sale" badge — only genuine
  // Shopify compare-at prices show one).
  // Reads the selling price from data-price (cents) so it stays correct across
  // filter/sort re-renders. Fully idempotent — each piece is guarded — so the
  // sweep can call it repeatedly without duplicating or looping.
  function applyToCard(card, aicoVal) {
    if (aicoVal == null) return;
    card.setAttribute("data-aico-val", aicoVal);
    let priceEl = card.querySelector(".af-productCard-price");
    if (!priceEl) return;

    let wl = card.querySelector(".uwl-col-wishlist");
    let cents = wl ? parseFloat(wl.getAttribute("data-price")) : NaN;
    let listEl = priceEl.querySelector(".aico-list-price");
    // Selling price: prefer data-price (cents); else parse the price text,
    // excluding our own crossed-out value and labels if already injected.
    let sellText = priceEl.textContent || "";
    Array.prototype.forEach.call(
      priceEl.querySelectorAll(".aico-list-price, .aico-price-label"),
      function (el) {
        sellText = sellText.replace(el.textContent, "");
      }
    );
    let cardPrice = !isNaN(cents)
      ? cents / 100
      : parseFloat(sellText.replace(/[^\d.]/g, ""));
    if (isNaN(cardPrice)) return;
    if (!(aicoVal > cardPrice)) return;

    // ~~AICO list price~~ before the selling price (styled via injected CSS).
    if (!listEl) {
      let prefix = (sellText.match(/^[^\d]*/) || ["CHF "])[0] || "CHF ";
      let s = document.createElement("s");
      s.className = "aico-list-price";
      s.textContent = prefix + Number(aicoVal).toFixed(2);
      priceEl.insertBefore(document.createTextNode(" "), priceEl.firstChild);
      priceEl.insertBefore(s, priceEl.firstChild);
      listEl = s;
    }
    // Bracket labels, as on the PDP: "(UVP, …)" after the crossed-out price and
    // "(B2B-Preis, …)" after the selling price (see aico_add_price_labels).
    let labels = window.aicoPriceLabels;
    if (labels && !priceEl.querySelector(".aico-price-label")) {
      let uvp = aico_price_label("uvp", labels.uvp);
      listEl.insertAdjacentElement("afterend", uvp);
      let lineBreak = document.createElement("span");
      lineBreak.className = "aico-price-break";
      uvp.insertAdjacentElement("afterend", lineBreak);
      priceEl.appendChild(aico_price_label("b2b", labels.b2b));
      priceEl.classList.add("aico-price-labels");
    }
    // Red selling price (via class). Per spec, AICO-driven prices must NOT show
    // a "Sale" badge — only genuine Shopify compare-at prices do.
    card.classList.add("aico-on-sale");
  }

  // Re-apply cached crosses/badges an app re-render may have wiped (no refetch).
  // applyToCard is idempotent, so calling it for every priced card is safe.
  function sweep() {
    let priced = container.querySelectorAll(".af-productCard[data-aico-val]");
    Array.prototype.forEach.call(priced, function (card) {
      applyToCard(card, parseFloat(card.getAttribute("data-aico-val")));
    });
  }

  // Process a batch of cards: handles -> skus -> CHF values (batched) -> apply.
  let queue = [];
  let flushTimer = null;
  function flush() {
    flushTimer = null;
    let batch = queue.splice(0, queue.length);
    let items = batch
      .map(function (card) {
        let link = card.querySelector('a[href*="/products/"]');
        let wl = card.querySelector(".uwl-col-wishlist");
        if (!link || !wl) return null;
        let handle = link
          .getAttribute("href")
          .split(/[?#]/)[0]
          .replace(/^.*\/products\//, "")
          .replace(/\/$/, "");
        return { card: card, handle: handle, variantId: wl.getAttribute("data-variant") };
      })
      .filter(Boolean);
    if (!items.length) return;

    Promise.all(
      items.map(function (it) {
        return resolveSku(it.handle, it.variantId).then(function (s) {
          it.sku = s;
        });
      })
    )
      .then(function () {
        return resolveVals(
          items.map(function (it) {
            return it.sku;
          })
        );
      })
      .then(function () {
        return Promise.all(
          items.map(function (it) {
            if (!it.sku) return;
            return valPromise[it.sku].then(function (val) {
              applyToCard(it.card, val);
            });
          })
        );
      })
      .catch(function () {});
  }
  function enqueue(card) {
    if (card.getAttribute("data-aico-done")) return;
    card.setAttribute("data-aico-done", "1");
    queue.push(card);
    if (!flushTimer) flushTimer = setTimeout(flush, 120);
  }

  // Lazy: resolve a card's AICO price only when it scrolls near the viewport.
  let io =
    typeof IntersectionObserver !== "undefined"
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (e) {
              if (e.isIntersecting) {
                io.unobserve(e.target);
                enqueue(e.target);
              }
            });
          },
          { rootMargin: "200px 0px" }
        )
      : null;

  function observeCards() {
    let cards = container.querySelectorAll(".af-productCard");
    Array.prototype.forEach.call(cards, function (card) {
      if (card.getAttribute("data-aico-obs")) return;
      card.setAttribute("data-aico-obs", "1");
      if (io) io.observe(card);
      else enqueue(card);
    });
  }

  observeCards();

  // The app re-renders the grid on filter/sort/paginate (replacing card nodes)
  // and aico-price-list.js may rewrite price text. Debounced: pick up new
  // cards and re-apply any wiped crosses. Idempotent apply => no mutation loop.
  if (typeof MutationObserver !== "undefined") {
    let moTimer = null;
    new MutationObserver(function () {
      if (moTimer) return;
      moTimer = setTimeout(function () {
        moTimer = null;
        observeCards();
        sweep();
      }, 200);
    }).observe(container, { childList: true, subtree: true });
  }
}

if (document.readyState !== "loading") {
  aico_filter_cards_setup();
} else {
  document.addEventListener("DOMContentLoaded", aico_filter_cards_setup);
}
